import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import { APP_NAV_ITEMS, NavigationIcon } from './navigation';
import { workspaceInitials } from '../utils/workspaceIdentity';

function Sidebar({ checkLogin, orgMember }) {
  if (!checkLogin()) return null;

  const groups = APP_NAV_ITEMS.reduce((result, item) => {
    result[item.group] = [...(result[item.group] || []), item];
    return result;
  }, {});
  const businessName = orgMember?.organization?.business_name || orgMember?.business_name || '';
  const workspaceName = businessName || 'Your workspace';
  const initials = workspaceInitials(businessName);

  return (
    <aside className="sidebar" data-say-id="sidebar-nav" aria-label="Main navigation">
      <div className="sidebar-workspace">
        <span className={`sidebar-workspace-mark${initials ? '' : ' is-empty'}`} data-testid="workspace-mark" aria-hidden="true">
          {initials || (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 21V7l8-4 8 4v14" />
              <path d="M9 21v-5h6v5M8 9h.01M12 9h.01M16 9h.01M8 12h.01M12 12h.01M16 12h.01" />
            </svg>
          )}
        </span>
        <span className="sidebar-workspace-copy">
          <span className="sidebar-workspace-label">Workspace</span>
          <strong>{workspaceName}</strong>
        </span>
      </div>

      <nav className="sidebar-nav">
        {Object.entries(groups).map(([group, items]) => (
          <div className="sidebar-group" key={group}>
            <span className="sidebar-group-label">{group}</span>
            {items.map((item) => (
              <NavLink key={item.path} to={item.path} data-say-id={`${item.path.slice(1)}-page`} className={({ isActive }) => `sidebar-button${isActive ? ' active' : ''}`}>
                <NavigationIcon name={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}

        {orgMember?.is_admin && (
          <div className="sidebar-group">
            <span className="sidebar-group-label">Administration</span>
            <NavLink end to="/operations" className={({ isActive }) => `sidebar-button${isActive ? ' active' : ''}`}>
              <NavigationIcon name="admin" />
              <span>Operations</span>
            </NavLink>
            <NavLink to="/operations/metrics" className={({ isActive }) => `sidebar-button${isActive ? ' active' : ''}`}>
              <NavigationIcon name="observability" />
              <span>Observability</span>
            </NavLink>
            <NavLink to="/operations/account-cleanup" className={({ isActive }) => `sidebar-button${isActive ? ' active' : ''}`}>
              <NavigationIcon name="cleanup" />
              <span>Account cleanup</span>
            </NavLink>
            <NavLink to="/operations/tester-invitations" className={({ isActive }) => `sidebar-button${isActive ? ' active' : ''}`}>
              <NavigationIcon name="invite" />
              <span>Tester invitations</span>
            </NavLink>
          </div>
        )}
      </nav>

      <NavLink to="/help" className="sidebar-help">
        <NavigationIcon name="help" />
        <span><strong>Need help?</strong><small>View guides and answers</small></span>
      </NavLink>
      <NavLink to="/privacy-policy" className="sidebar-legal">Privacy Policy</NavLink>
    </aside>
  );
}

export default Sidebar;
